import { Search } from "@outschool/business-rules";

const AGE_STRING_LENGTH_LIMIT = 17;

export function createAgeString(ages: Array<number>): string {
  let text = Search.agesArrayToString(ages.map(a => a.toString()));

  if (text.length <= AGE_STRING_LENGTH_LIMIT) {
    return text;
  }

  const truncatedText = text.slice(0, AGE_STRING_LENGTH_LIMIT);
  const ellipsisIndex = truncatedText.lastIndexOf(",");

  return `${truncatedText.slice(0, ellipsisIndex)}...`;
}
